import React from 'react';
import { VALID_PAGE_SIZES } from '@/hooks/usePagination';
import { classNames } from '@/utils/classNames';

interface PageSizeSelectorProps {
  pageSize: number;
  totalItems: number;
  onPageSizeChange: (size: number) => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const PageSizeSelector: React.FC<PageSizeSelectorProps> = ({
  pageSize,
  totalItems,
  onPageSizeChange,
  className,
  size = 'md',
}) => {
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-2',
    lg: 'text-base px-4 py-2',
  };

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = parseInt(event.target.value, 10);
    onPageSizeChange(newSize);
  };

  return (
    <div className={classNames('flex items-center gap-2', className)}>
      <label
        htmlFor='page-size-selector'
        className='text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap'
      >
        表示件数:
      </label>
      <select
        id='page-size-selector'
        value={pageSize}
        onChange={handleChange}
        className={classNames(
          'block rounded-md border border-gray-300 dark:border-gray-600',
          'bg-white dark:bg-gray-800',
          'text-gray-900 dark:text-white',
          'focus:border-primary-500 focus:ring-primary-500',
          'disabled:bg-gray-50 dark:disabled:bg-gray-700',
          'disabled:text-gray-500 dark:disabled:text-gray-400',
          sizeClasses[size]
        )}
        aria-label='1ページあたりの表示件数を選択'
      >
        {VALID_PAGE_SIZES.map(size => (
          <option key={size} value={size}>
            {size}件
          </option>
        ))}
      </select>
      <span className='text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap'>
        / 全{totalItems.toLocaleString()}件
      </span>
    </div>
  );
};
